import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { sortBy } from 'lodash';
import { Collection } from '@shopthrilling/thrilling-shared';

import { FirestoreService } from '../../services/firestore/firestore.service';
import { ShopifyAdminService } from '../../modules/shopify-admin/shopify-admin.service';


@Injectable({
	providedIn : 'root',
})
export class CollectionService {
	private collectionsRef : AngularFirestoreCollection<Collection>;


	constructor(
		private firestore      : FirestoreService,
		private shopifyGraphql : ShopifyAdminService,
	) {
		this.collectionsRef = this.firestore.getRef('collections');
	}


	/*
	 * Read Methods - new
	 * pull from Firestore
	 */
	getAll() : Observable<Collection[]> {
		return this.collectionsRef.valueChanges().pipe(
			// tap(data => console.debug(data)),
			map(list => sortBy(list, ['title'])),
			// tap(data => console.debug(data)),
		);
	}


	/*
	 * Read Methods - old
	 * pull from Shopify
	 */
	getByIdFromShopify(id : string, customFields? : string) : Observable<any> {
		return this.shopifyGraphql.getCollectionById(id, customFields).pipe(
			// tap(data => console.debug(data)),
			map(data => data?.data?.collection),
			// tap(data => console.debug(data)),
		);
	}

	getByHandleFromShopify(handle : string) : Observable<any> {
		return this.shopifyGraphql.getCollectionByHandle(handle)
			.pipe(
				take(1),
			);
	}

	/*
	 * Write Methods
	 * push to Firestore
	 */
	delete(id : string) : Promise<void> {
		return this.collectionsRef.doc(id).delete();
	}


	/*
	 * Write Methods
	 * push to Shopify
	 */
	addProductsToCollection(id : string, productIds : string[]) : Observable<any> {
		return this.shopifyGraphql.addProductsToCollection(id, productIds)
			.pipe(
				take(1),
			);
	}

	createInShopify(input : any) : Observable<any> {
		return this.shopifyGraphql.createCollection(input)
			.pipe(
				take(1),
			);
	}

	updateInShopify(id : string, updates : any) : Observable<any> {
		return this.shopifyGraphql.updateCollection(id, updates)
			.pipe(
				take(1),
				map(data => data?.data?.collectionUpdate),
			);
	}

	publishToShopify(shopifyId : string) : Observable<any> {
		return this.shopifyGraphql.publish(shopifyId).pipe(
			take(1),
			// tap(data => console.debug(data)),
		);
	}

	deleteFromShopify(id : string) : Observable<any> {
		return this.shopifyGraphql.deleteCollection(id)
			.pipe(
				take(1),
			);
	}
}
